<template>
  <el-container class="mycontainer" style="padding:0">
    <!-- 侧边栏 -->
    <el-aside width="200px" style="background: rgb(246, 248, 251);height:100%">
      <LeftBar :left-items="leftItems" :currentSelectLeftItemKey="currentSelectLeftItemKey" @selectChange="leftItemselectChange"/>
    </el-aside>
    <!-- 主要内容容器 -->
    <el-container style="position:relative;height:100%">
      <!-- 容器顶部筛选条件按钮 -->
      <el-header style="height: 60px;background: white;display: flex;justify-content: space-between;align-items: flex-end;">
        <CustomTool style="width:100%;" :show-time-area="false" :show-time="true" :show-refresh="true" :show-filter="false" :show-export="false" :filterArchiveData="filterArchiveData" @filters="filterContentChange" @export="exportExcel"/>
      </el-header>
      <div  style="overflow: scroll;height:100%;">

        <div v-for="tableRow in tables" style="height:600px;display: flex;">

          <div v-for="table in tableRow" style="height:100%;" :style="{width:`${100 / tableRow.length}%`}">
            <div style="display:flex;justify-content: space-between;align-items: end;margin-right:20px;">
              <div style="height:50px;margin-left:40px;font-size:30px;font-weight: 600;">{{table.title}}</div>
              <div style="display: flex;">
                <el-button v-if="table.showWithdraw" size="mini" style="margin-bottom: 10px;margin-top:15px;" @click="withdrawAction(table)">提现</el-button>
                <CustomTool :column_mapper="table.toolConfig.column_mapper" :show-time-area="false" :show-time="false" :show-refresh="false" :show-filter="true" :show-export="true" :filterArchiveData="table.toolConfig.filterArchiveData" @filters="(content)=>tableFilterContentChange(table,content)" @export="exportExcel(table)"/>
              </div>
            </div>
            <custom-table
                style="height:calc(100% - 80px)"
                :ref="table.dimension"
                :table-id="table.dimension"
                @row-click="rowClick"
                :project-list-dl="table.tableData.showProjectList"

                :show-coloums-dl="table.tableData.showColoums"
                :column_mapper="table.tableData.column_mapper"

                @sort-change="sortChange"
                :sort-column-name-dl="table.tableData.sortColumnName"
                :sort-column-order-dl="table.tableData.sortColumnOrder"

                @current-change="(e)=>currentChange(table.tableData,e)"
                :totalnums-dl="table.tableData.totalnums"
                :pagesize-dl="table.tableData.pagesize"
                :page-number-dl="table.tableData.pageNumber"

                :fixed-columns="table.tableData.fixedList"

                :disableDrag="true"

                :sortable="false"

                :pagination="table.tableData.pagination"

                :is-loading-dl="table.tableData.detailLoading"
                :use-virtual="false"
                :row-hegit="0"

                :tableColumnCustomConfig="table.tableData.tableColumnCustomConfig"
                @unusualShow="unusualShow"
                :custom-tabel-height-offset="610"
                :isSmallPage="true"
                :show-summary="true"
                :summary-method="(v)=>getSummaries(v,table.tableData.sum)"
            ></custom-table>
          </div>
        </div>
      </div>

      <WithdrawSelection v-model="showDialog" :withDrawList="withDrawList" @updateTable="updateTable"/>

    </el-container>
  </el-container>
</template>

<script>
import CustomTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import CustomCard from "@/component/Performance/CustomCard";
import CustomDialog from "@/component/PrePayManage/dialog/CustomDialog";
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import {
  exportAdvance,
  getUnusualList, getAdvance
} from '../../api/api'
import {getMonthStartDate} from "@/utils/util";
import WithdrawSelection from "@/component/PrizeAccount/WithdrawSelection";
export default {
  name: "PrizeAccount",
  props:["refreshId"],
  components:{
    CustomTable,
    CustomTool,
    CustomCard,
    CustomDialog,
    LeftBar,
    WithdrawSelection
  },
  data(){
    return {
      showDialog:false,
      withDrawTable:null,
      withDrawList:[],
      column_mapper:{
        "advance_name":"预付款名称:like",
        "stat_time":"结算日期:date",
        "client_name": "客户:varchar"
      },

      tables:[
        [
          {
            dimension: "client_name",
            title: "客户余额表",
            toolConfig: {
              sort:{},
              showFilter:false,
              showTimeArea:false,
              column_mapper:{
                client_name: "客户:varchar"
              },
              filterContent:{
                queryCond: [],
                sortCond: {
                  columnName: "",
                  value: ""
                },
                timerange:{
                  start:"",
                  end:""
                }
              },
              defaultDateArea:{
                defaultStart:"",
                defaultEnd:""
              },
              filterArchiveData:{
                start_end_date_dynamic:[],
                queryCond: []
              }
            },
            tableData: {
              sum:0,
              //表格列表相关
              detailLoading: false,
              projectList: [],//表格列表所有数据
              showProjectList: [],//显示的数据
              column_mapper: {},//表头所有列的枚举
              showColoums: [],//当前显示的表头列
              sortColumnName: "",//需要排序的列名
              sortColumnOrder: "",//排序的命令
              totalnums: 10,//所有的数据条数
              pageNumber: 1,//当前页
              fixedList: ['project:project_id', 'project:project_name'],
              pagesize: 10,//一页数据的行数（公用）
              pagination: true,
              tableColumnCustomConfig: {//图表某些列定制化显示
                'project:project_id': {
                  type: "popover",
                  showRule: {
                    key:"project:project_comment",
                    // 不为空
                    value:""
                  },
                  project_id: "",
                  closeTime: 1,
                  openTime: 0,
                  forceClose: false,
                  show: false,
                  popoverDatas: []
                }
              }
            }
          },
          {
            dimension: "platform",
            title: "渠道余额表",
            toolConfig: {
              sort:{},
              showFilter:false,
              showTimeArea:false,
              column_mapper:{
                platform: "平台:varchar"
              },
              filterContent:{
                queryCond: [],
                sortCond: {
                  columnName: "",
                  value: ""
                },
                timerange:{
                  start:"",
                  end:""
                }
              },
              defaultDateArea:{
                defaultStart:"",
                defaultEnd:""
              },
              filterArchiveData:{
                start_end_date_dynamic:[],
                queryCond: []
              }
            },
            tableData: {
              //表格列表相关
              sum:0,
              detailLoading: false,
              projectList: [],//表格列表所有数据
              showProjectList: [],//显示的数据
              column_mapper: {},//表头所有列的枚举
              showColoums: [],//当前显示的表头列
              sortColumnName: "",//需要排序的列名
              sortColumnOrder: "",//排序的命令
              totalnums: 10,//所有的数据条数
              pageNumber: 1,//当前页
              fixedList: ['project:project_id', 'project:project_name'],
              pagesize: 10,//一页数据的行数（公用）
              pagination: true,
              tableColumnCustomConfig: {//图表某些列定制化显示
                'project:project_id': {
                  type: "popover",
                  showRule: {
                    key:"project:project_comment",
                    // 不为空
                    value:""
                  },
                  project_id: "",
                  closeTime: 1,
                  openTime: 0,
                  forceClose: false,
                  show: false,
                  popoverDatas: []
                }
              }
            }
          }],
        [
          {
            dimension: "project",
            title: "订单余额表",
            showWithdraw:true,
            toolConfig: {
              sort:{},
              showFilter:true,
              showTimeArea:false,
              column_mapper:{
                platform: "平台:varchar",
                project_id: "项目编号:varchar"
              },
              filterContent:{
                queryCond: [],
                sortCond: {
                  columnName: "",
                  value: ""
                },
                timerange:{
                  start:"",
                  end:""
                }
              },
              defaultDateArea:{
                defaultStart:"",
                defaultEnd:""
              },
              filterArchiveData:{
                start_end_date_dynamic:[],
                queryCond: []
              }
            },
            tableData: {
              sum:0,
              //表格列表相关
              detailLoading: false,
              projectList: [],//表格列表所有数据
              showProjectList: [],//显示的数据
              column_mapper: {},//表头所有列的枚举
              showColoums: [],//当前显示的表头列
              sortColumnName: "",//需要排序的列名
              sortColumnOrder: "",//排序的命令
              totalnums: 10,//所有的数据条数
              pageNumber: 1,//当前页
              fixedList: ['project:project_id', 'project:project_name'],
              pagesize: 10,//一页数据的行数（公用）
              pagination: true,
              tableColumnCustomConfig: {//图表某些列定制化显示
                'project:project_id': {
                  type: "popover",
                  showRule: {
                    key: "project:project_remark",
                    value: "异常"
                  },
                  project_id: "",
                  closeTime: 1,
                  openTime: 0,
                  forceClose: false,
                  show: false,
                  popoverDatas: []
                }
              }
            }
          }
        ]
      ],


      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        tableColumnCustomConfig:{//图表某些列定制化显示
          'project:project_id':{
            type:"popover",
            showRule:{
              key:"project:project_remark",
              value:"异常"
            },
            project_id:"",
            closeTime:1,
            openTime:0,
            forceClose:false,
            show:false,
            popoverDatas:[]
          }
        }
      },
      leftItems: [
        {
          id: 0,
          name: "发奖账户管理",
          key: "prize"
        }
      ],
      currentSelectLeftItemKey:"prize",


      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
        time:(new Date()).format('yyyy-MM-dd')
      },
      filterArchiveData:{
        start_end_date_dynamic:[],
        queryCond: []
      },

      showTimeArea:true
    }
  },
  async mounted() {
    window.vm4 = this
    this.refresh()
  },

  watch:{
    refreshId(newVal){
      // console.log('refreshId change,刷新todoList',newVal)
      this.refresh(false)
    },
  },

  methods:{
    withdrawAction(table){
      this.withDrawList = table.tableData.projectList
      this.withDrawTable = table
      this.showDialog = true
    },
    updateTable() {
      this.refresh(true,this.withDrawTable)
    },
    getSummaries(param,sum) {
      const { columns, data } = param;
      // console.log('param',param)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        // console.log('values',values)
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '';
        }
      });
      sums[sums.length-1] = sum.toLocaleString()
      // console.log('sums',sums)
      return [sums];
    },
    filterContentChange(content){
      // console.log('filterContentChange',content)
      Object.assign(this.filterContent,content)
      this.refresh()
      // this.getPerformanceData()
    },

    tableFilterContentChange(table,content){
      // console.log('tableFilterContentChange',content)
      Object.assign(table.toolConfig.filterContent,content)
      this.refresh(true,table)
      // this.getPerformanceData()
    },

    async exportExcel(table){
      let dimension = table.dimension
      let param = {
        index: "balance",
        division:this.currentSelectLeftItemKey,
        dimension:dimension,
        pagiInfo: {
          currentPage: table.tableData.pageNumber,
          pagesize: table.tableData.pagesize
        },
        ...table.toolConfig.filterContent,
        timerange:{
          start:"2018-01-01",
          end:this.filterContent.time
        }
      }
      // let param = {
      //   division:this.currentSelectLeftItemKey
      // }
      // console.log('exportFinancial/param',param)
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportAdvance(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        let fileName = table.title + '-' + Y + M + D + H + m + s + ".xlsx"

        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    },

    async unusualShow(project_id){
      let res = await getUnusualList({project_id: project_id})
      let resData = res.data

      if (resData.hasOwnProperty('respCode')) {
        if (resData.respCode == "000000") {
          this.tableData.tableColumnCustomConfig['project:project_id'].project_id = project_id
          this.tableData.tableColumnCustomConfig['project:project_id'].popoverDatas = resData.respData
        } else {
          this.$message.warning(resData.respMsg)
        }
      } else {
        this.$message.error("数据有误")
      }
    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick(e) {
      this.dialogRequestData = e
      this.dialogFormVisible = true
      // console.log('rowClick', e['project:project_name'])
      // this.$store.commit("setProjectId", e["project:project_id"]);
      // this.$store.commit("setProjectInfo", {
      //   projectId: e["project:project_id"],
      //   projectName: e["project:project_name"],
      //   accu: 0
      // })
    },
    sortChange(e) {
      // console.log('sortChange',e)

      if (e.order === null) {
        this.filterContent.sortCond.columnName = ""
        this.filterContent.sortCond.value = ""
      } else {
        this.filterContent.sortCond.columnName  = e.prop
        if (e.order === 'ascending') {
          this.filterContent.sortCond.value = 'asc'
        } else {
          this.filterContent.sortCond.value = 'desc'
        }
      }
      this.refresh()
    },

    async currentChange(tableData,e) {
      // console.log('currentChange',e)
      tableData.pageNumber = e;
      this.getCurrentPageData(tableData)
    },

    shourtcutSelectChange(key){
      this.contentMap[this.currentSelectLeftItemKey].selectShortcutId = key
      this.refresh()
    },

    leftItemselectChange(key){
      // console.log('左侧item切换',key)
      this.currentSelectLeftItemKey = key
      this.refresh()
    },



    async getData(resetPage=false,table){

      let tables = []
      if(table){
        tables.push(table)
      }else{
        tables =this.tables.reduce((a,b)=>[...a,...b],[])
      }
      for (const table of tables) {
        table.tableData.detailLoading = true
      }
      for (const table of tables) {
        if(resetPage){
          table.tableData.pageNumber = 1
        }
        let dimension = table.dimension

        let postData = {
          index: "balance",
          division:this.currentSelectLeftItemKey,
          dimension:dimension,
          pagiInfo: {
            currentPage: table.tableData.pageNumber,
            pagesize: table.tableData.pagesize
          },
          ...table.toolConfig.filterContent,
          timerange:{
            start:"2018-01-01",
            end:this.filterContent.time
          },
        }


        // let postData = this.filterRequestData
        // console.log('postData', postData)
        let res = await getAdvance(postData)
        let resData = res.data

        if (!resData || !resData.respData) {
          if (resData && resData.respMsg) {
            this.$message.warning(resData.respMsg)
          }
          table.tableData.column_mapper = {}
          table.tableData.projectList = []
          table.tableData.sum = 0
          table.tableData.totalnums = 0
          table.tableData.showColoums = []
          this.getCurrentPageData(table.tableData)
          this.$nextTick(() => {
            table.tableData.detailLoading = false
          })
          continue
        }

        const {cols_mapper, data, columns_list, sum} = resData.respData
        // console.log('返回结果', resData,cols_mapper,data,columns_list)
        table.tableData.column_mapper = cols_mapper || {}
        table.tableData.projectList = data || []
        table.tableData.sum = sum || 0
        table.tableData.totalnums = (data || []).length
        table.tableData.showColoums = columns_list || []
        // console.log('table.tableData.showColoums',table.tableData.showColoums )
        this.getCurrentPageData(table.tableData)

        this.$nextTick(() => {
          table.tableData.detailLoading = false
        })
      }



    },

    getCurrentPageData(tableData){
      if(tableData.projectList.length > tableData.pagesize){
        tableData.showProjectList = tableData.projectList.slice((tableData.pageNumber-1)*tableData.pagesize,(tableData.pageNumber)*tableData.pagesize)
      }else{
        tableData.showProjectList = tableData.projectList
      }
    },

    async refresh(resetPage=true,table){
      // for (const tableRow of this.tables) {
      //   console.log('tableRow',tableRow)
      //   for (const table of tableRow) {
      //     console.log('table',table)
      //
      //     table.tableData.detailLoading = true
      //   }
      // }
      await this.getData(resetPage,table)
    }
  }
}
</script>
<style lang="scss">
.mycontainer{
  .has-gutter tr > td:nth-child(2) {
    text-align: right;
    .cell{
      margin-right:10px;
    }
  }
  .has-gutter tr > td:nth-child(4) {
    text-align: right;
    .cell{
      margin-right:10px;
    }
  }
}

.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height:200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

